import React from 'react';
import { IQuestionnaireRequestData } from 'pages/formsCreate/types';
import { useStyles } from './styles';
import { DateLabel } from './DateLabel';
import { RequiredDisplay } from './RequiredDisplay';

interface IProps {
  data: Omit<IQuestionnaireRequestData, 'supplierList' | 'inSketch' | 'id'> & { id?: string };
}

export const FormAbout = ({ data: { startDate, endDate, title, required, description } }: IProps) => {
  const { containerMain, formAbout, containerTitle } = useStyles();
  return (
    <div className={containerMain}>
      <div>
        <div className={containerTitle}>
          <h2>{title || '-'}</h2>
          <RequiredDisplay isRequired={required} />
        </div>
        <span className={formAbout}>
          <DateLabel label="Data de Início" value={startDate} />
          <DateLabel label="Data de Término" value={endDate} />
        </span>
      </div>
      <p>{description}</p>
    </div>
  );
};
